import { gql } from '@phoenix-web/ux-gql'

export type UserAccountInfoResponse = {
  userAccountInfo: {
    person_id: string
    account_id: string
    employee_id: string
    first_name: string
    last_name: string
    email: string
    phone: string | null
    mobile_phone: string | null
    email_verify: boolean
    active: boolean
    roles: {
      is_homebuyer: boolean
      is_agent: boolean
      is_lender: boolean
    } | null
    metadata: {
      nmls_id?: string
      has_homebuyer_transactions?: boolean
      has_agent_leads?: boolean
      has_lender_leads?: boolean
    } | null
  }
}

export const GET_USER_ACCOUNT_INFO = gql`
  query userAccountInfo {
    userAccountInfo {
      person_id
      account_id
      employee_id
      first_name
      last_name
      email
      phone
      mobile_phone
      email_verify
      active
      roles {
        is_homebuyer
        is_agent
        is_lender
      }
      metadata {
        nmls_id
        has_homebuyer_transactions
        has_agent_leads
        has_lender_leads
      }
    }
  }
`
